var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo__link",attrs:{"to":{ name: 'home' }}},[_c('div',{staticClass:"logo__img"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":"空英老師專區"}})]),_c('div',{staticClass:"logo__title"},[_vm._v("\n      空英老師專區\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }